<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Properties'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>

  <tidy-wrapper>
    <tidy-alert class="green-background">
      <tidy-text [body]="'Please add a property before completing this step.'" />
    </tidy-alert>

    <tidy-card>
      <tidy-card-button (action)="goToAddDirectIntegration()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/img/integrate.svg'" style="width: 20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Import All Properties via PMS Integration'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'If you use a PMS system you can integrate to import all properties.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card>
      <tidy-card-button (action)="goToImportCSV()" class="no-below-stroke">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/img/csv.svg'" style="width: 20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Import CSV'" />
            </tidy-row>
            <tidy-row>
              <tidy-text [body]="'Import all properties by importing a CSV.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-row class="extra-bottom-padding">
      <tidy-text [helper]="'or'" class="divider" />
    </tidy-row>

    @for (form of forms.controls; track form; let first = $first; let index = $index) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row [ngClass]="first ? 'card-header vertical-align-center' : 'card-header extra-bottom-padding'" [alignLastItemRight]="!first">
            <span>
              <tidy-text [header]="'Property'" />
              <tidy-text [header]="' #' + ((index | translate) + (1 | translate))" />
            </span>
            @if (!first) {
              <tidy-text
                class="link red"
                [body]="'Remove'"
                (action)="removeProperty(form)" />
            }
          </tidy-row>
          @if (first) {
            <tidy-row>
              <tidy-input-international-phone
                formControlName="phone"
                [label]="'Phone'"
                [form]="form.controls.phone"
                [inputMode]="'numeric'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid phone.'"
                [icon]="'assets/svg/phone-portrait.svg'"
                [initialMask]="{ mask: '[00000000000000000000000]' }"
                (countryCodeChange)="onCountryCodeChange($event)" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-select
              [icon]="'assets/svg/location.svg'"
              [label]="'Country'"
              [items]="countryList"
              [form]="form.get('countryCode')"
              formControlName="countryCode"
              (optionChange)="changeCountrySelected($event, form)" />
          </tidy-row>
          <tidy-row>
            <tidy-auto-complete
              label="Address"
              formControlName="address"
              [options]="autocompleteAddress"
              [icon]="'assets/svg/home.svg'"
              [form]="form.controls.address"
              [errorMessage]="'Please enter a valid address'"
              [submitted]="submitted"
              (keyup)="updateSearch(form)"
              (action)="chooseItem($event, form)" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="address2"
              [form]="form.controls.address2"
              label="Unit / Apartment"
              [errorMessage]="'Please enter a valid unit'"
              [submitted]="submitted"
              [icon]="'assets/img/door.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="zipcode"
              [customMask]="zipCodeMask"
              [form]="form.controls.zipcode"
              [errorMessage]="'Please enter a valid zipcode'"
              [submitted]="submitted"
              [inputMode]="'numeric'"
              label="Postal Code"
              [icon]="'assets/img/mailbox.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              formControlName="addressNickname"
              [form]="form.controls.addressNickname"
              [label]="'Property Nickname (optional)'"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
          @if (
            radioButtonAddress.length > 0 &&
            submitted &&
            (typedOnAddress || !didChooseAddress)
            ) {
            <tidy-row>
              <tidy-text [header]="'Please confirm your address:'" />
            </tidy-row>
            <tidy-row>
              <tidy-radio-button
                [helper]="'If you do not see your address please retype it above'"
                [items]="radioButtonAddress"
                (optionChange)="chooseItem($event, form); setAddressFormControl($event)" />
            </tidy-row>
          }
        </form>
      </tidy-card>
    }

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    <tidy-row [align]="'center'">
      <tidy-text
        [actionBody]="'+ Add Another Property'"
        (action)="addAnotherProperty()"
        class="link" />
    </tidy-row>

    <tidy-row class="extra-top-padding">
      <tidy-button
        [text]="forms.controls.length > 1 ? 'Add Properties' : 'Add Property'"
        class="primary"
        [action]="boundAddProperty" />
    </tidy-row>
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
